var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNvsChatbotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 486,
    viewBox: "0 0 486 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 110) scale(8.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 30,
    rx: 10,
    stroke: "#0066FF",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 4,
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 15,
    r: 4,
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30 L18 40 H34 L26 30Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvsChatbotIcon);
export default __webpack_public_path__ + "static/media/nvs-chatbot-icon.e526167541f94c488e0f60e84021e406.svg";
export { ForwardRef as ReactComponent };